import { createFileRoute } from "@tanstack/react-router";
import AdminAccelerator from "@/pages/AdminAccelerator";

export const Route = createFileRoute("/admin/accelerator/")({
  component: AdminAccelerator,
});
